import React, {useState, useEffect} from "react";
import { Form, Col, Input, Collapse ,Card} from 'antd';
import jsonfile from './collection.json'
import {useHistory} from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import ActionButton from '../../../../util/actionbutton';
import SmartDataTable from 'react-smart-data-table';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import IntlMessages from "util/IntlMessages";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";

const Search = Input.Search;
const Panel = Collapse.Panel;

const TithlyCollectionHistory = () => {
    const value = 0;
    const [total,setTotal] = useState(0);
    const [state,setState] = useState({
        reqURL: Config.apiserver+jsonfile.urls.tithly,
        reqURLsum: Config.apiserver+"donation/tithlycollectionsummary",
        filtervalue : '',
        subtitle : '',
    });

    const [summary,setSummary] = useState({
        tamount : 0,
        tfees : 0,
        tnet : 0
    });

    const getTotalSummary = (url) => {
        axios.get(url)
            .then(res => {
                console.log(res);
                if(res.data.status === 1) {
                    const data = res.data.data;
                    setSummary({
                        tamount: data.tamount || 0,
                        tfees: data.tfees || 0,
                        tnet: data.tnet || 0
                    });
                }
            })
            .catch(errors => {
                console.log(errors);
                // msg = (errors);
                //setLoading({loading:false});
                //setResponse([]);
                //document.getElementById("loader").style.display = "none";
            });
    }

    useEffect(() => {
        getTotalSummary(state.reqURLsum);
    }, []);


    const history = useHistory();

    const headers = {
        // _id: {
        //     text: '#',
        //     invisible: false,
        //     filterable: false,
        //     transform: (value) => `${++value}`,
        // },
        id: {
            invisible : true
        },
        member_id: {
            invisible : true
        },
        com_id: {
            invisible : true
        },
        amount: {
            text: <IntlMessages id="Amount"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        fees: {
            text: <IntlMessages id="Fess"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        net_amount: {
            text: <IntlMessages id="Net Amount"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        deposit_date: {
            text: <IntlMessages id="Deposit Date"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().DateFormat(value)
            )
        },
        trx_date: {
            text: <IntlMessages id="Transaction Date"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().DateFormat(value)
            )
        },
        // actions: {
        //     text: 'Actions',
        //     sortable: false,
        //     filterable: false,
        //     transform: (value, idx, row) => (
        //         <>
        //             {ActionButton(row.id,jsonfile.urls,jsonfile.urls.list)}
        //         </>
        //     ),
        // },
    };

    const orderedHeaders = jsonfile.listView.tithly_title;

    const getFields = () => {
        const count = expand ? 10 : 6;
        const children = [];
        const inputs = jsonfile.input;

        inputs.map((list, index) => {
            if(list.isFilterable == 1) {
                children.push(
                    <Col lg={6} md={6} sm={12} xs={24} key={index} style={{display: index < count ? 'block' : 'none'}}>
                        <div className="gx-form-row0">
                            <Form.Item
                                name={`${list.name}`}
                                label={`${list.label}`}
                                rules={[
                                    {
                                        required: true,
                                        message: "",
                                    },
                                ]}
                            >
                                <Input placeholder={list.name} />
                            </Form.Item>
                        </div>
                    </Col>,
                );
            }
        });
        return children;
    };

    const [expand, setExpand] = useState(false);
    const [form] = Form.useForm();

    const onFinish = values => {
        console.log('Received values of form: ', values);
        const qsup = CisUI().getQueryStrings(values);
        //reqURL = reqURL+"/?"+qsup;
        history.push("?"+qsup);
        const newURL = Config.apiserver+jsonfile.urls.list+"/?"+qsup;
        const newSumURL = Config.apiserver+"donation/collectionsummary/?"+qsup;
        setState({reqURL: newURL, reqURLsum : newSumURL});
        setTotal(0);
        getTotalSummary(newSumURL);
    };

    const handleOnFilter = ({ target: { name, value } }) => {
        //filterValue = value;
        console.log("filteringwith :"+ value);
        setState({filtervalue : "test"});
    }

    let  searchView = "";
    if(jsonfile.has_search) {
        searchView = <Card className="advance-search-card">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']} >
                <Panel header="Advance Search"  key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch(jsonfile.input,"",1,"date",CisUI().PeriodFiled(form))}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const getExtra = (
        <>
            {/*<Search*/}
            {/*    placeholder='Filter...'*/}
            {/*    name='filtervalue'*/}
            {/*    onSearch={handleOnFilter}*/}
            {/*    onChange={handleOnFilter}*/}
            {/*    style={{width: 200}}*/}
            {/*/>*/}
            {CisUI().listAction("../"+jsonfile.urls.add,"",state.reqURL,"data","contributions",jsonfile,state.subtitle, "landscape")}
        </>
    );

    return (
        <>
            {/*{searchView}*/}
            <Card title="Collections from Tithly" extra={getExtra}>
                <SmartDataTable
                    name='test-fake-table'
                    data={state.reqURL}
                    dataRequestOptions={CisUI().HeaderRequest}
                    dataKey="data"
                    headers={headers}
                    orderedHeaders={orderedHeaders}
                    hideUnordered={CisUI().hideUnordered}
                    className={CisUI().sematicUI.table}
                    filterValue={state.filterValue}
                    perPage={CisUI().perPage}
                    sortable
                    withLinks
                    withHeader
                    // withToggles
                    loader={CisUI().loader}
                    parseBool={{
                        yesWord: 'Yes',
                        noWord: 'No',
                    }}
                    parseImg={{
                        style: {
                            border: '1px solid #ddd',
                            borderRadius: '50px',
                            padding: '3px',
                            width: '30px',
                            height: '30px'
                        },
                    }}
                    emptyTable={CisUI().emptyTable}
                />

                <div className="row">
                    <div className="col-md-12" style={{textAlign: 'center'}}>

                        <table className="table -table-no-bordered mx-auto w-auto" style={{width: '400px'}}>
                            <tr>
                                <th style={{textAlign: 'right'}}>Total Amount :</th>
                                <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(summary.tamount || 0)}</td>
                            </tr>
                            <tr>
                                <th style={{textAlign: 'right'}}>Total Fees :</th>
                                <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(summary.tfees || 0)}</td>
                            </tr>
                            <tr>
                                <th style={{textAlign: 'right'}}>Total Net Amount :</th>
                                <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(summary.tnet || 0)}</td>
                            </tr>
                        </table>

                    </div>
                </div>

            </Card>
        </>
    );
};

export default TithlyCollectionHistory;